import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';

@Component({
  selector: 'app-external-page',
  templateUrl: './external-page.component.html',
  styleUrls: ['./external-page.component.scss']
})
export class ExternalPageComponent implements OnInit {


  id = this.route.snapshot.paramMap.get('id');
  @Input() formData = JSON.parse(JSON.stringify(StaticDataService.defaultPageData));
  showLoader = false;
  domainConfig = null;
  pagesDisabled = [];
  autocompletelist: any = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private restService: RestDataService,
    private config: Config,
    private snotify: SnotifyService,
    private sharedService: SharedDataService
  ) {
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.pagesDisabled = this.domainConfig['pagesDisabled'] || [];
    if (this.pagesDisabled.indexOf('EXTERNAL') > -1) {
      this.snotify.error('External Page is not enabled for this domain', '', this.sharedService.getConfig(false));
      this.resetForm();
    }
  }

  ngOnInit() {
    if (this.id && this.id.indexOf('?domain') > -1) {
      this.id = this.id.substring(0, this.id.indexOf('?domain'));
    }
    if (this.id !== null) {
      this.showLoader = true;
      this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/' + this.id).subscribe(data => {
        // console.log(data);
        this.formData = data;
        this.showLoader = false;
      },
        err => {
          console.log(err);
          this.snotify.error('Page Id doesn\'t exist', '', this.sharedService.getConfig(false));
          this.resetForm();
          this.showLoader = false;
        });
    }
    if(sessionStorage.getItem(StaticDataService.domainLiteral) === '5df8a1b2e75f583b86696dbb') {
      this.restService.http_get(
        this.config.get('product').baseUrl + '/api/cms/story/productcategories'
          ).subscribe(res => {
           res.map((category)=> {
            this.autocompletelist.push(category.categoryName);
           })
          });
      console.log("TECH")
    } else {
      this.autocompletelist = ['car','bike'];
      console.log("OTHER")
    }

  }

  resetForm() {
    this.formData = null;
    this.router.navigate(['/dash/pages']);
  }

  savePage() {
    this.formData.pageType = 'EXTERNAL';
    this.formData.status = 'PUBLISHED';
    if (this.formData.name && this.formData.name.trim() !== ''
      && this.formData.externalUrl && this.formData.externalUrl.trim() !== '') {
      if (this.formData.id) {
        // console.log('update data ', this.formData);
        this.updateOverride();
      } else {
        this.snotify.info('Creating external page...', '', this.sharedService.getConfig(false));
        // console.log(this.formData.pageSubtype, this.formData.pageSubtypeCategory)
        // console.log('create new ', this.formData);
        this.restService.http_post(this.config.get('product').baseUrl + StaticViewDataService.externalPageAPI,
        this.formData,
        data => {
          // console.log(data);
          this.snotify.success('Page created successfully', '', this.sharedService.getConfig(false));
          // console.log(window.location.origin + "/dash/page/"+ data.id)
          setTimeout(() => {
            // window.open(window.location.origin + "/dash/page/"+ data.id);  
            this.router.navigate(['/dash/page/' + data.id]);
          }, 2000);
          this.formData = null;
        });
      }
    } else {
      this.snotify.error('Name and URL are mandatory', '', this.sharedService.getConfig(false));
    }
  }

  toggleSwitch(type){
    if(type === 'autobacklink'){
      console.log(this.formData)
      this.formData.toBeAutobacklink = !this.formData.toBeAutobacklink;
    }
    if(type === 'noFollow'){
      this.formData.noFollow = !this.formData.noFollow;
    }
  }
  setType(type, ev) {
    this.formData[type] = ev[0];
    console.log(this.formData[type])
  }

  updateOverride() {
    this.lockAcquire(this.formData.id).subscribe(
      acquired => {
        this.restService.http_put(this.config.get('product').baseUrl + StaticViewDataService.externalPageAPI + '/' + this.formData.id,
        this.formData,
        data => {
          // console.log(data);
          this.snotify.success('Page Updated successfully', '', this.sharedService.getConfig(false));
          this.lockRelease(this.formData.id).subscribe();
          this.resetForm();
        });
      },
      err => {
        this.snotify.error('Page is locked by someone else, Cannot save', '', this.sharedService.getConfig(false));
      }
    );
  }

  lockAcquire(story_id) {
      return this.restService.http_get(
        this.config.get('product').baseUrl
        + StaticViewDataService.pageLockAcquireAPI
        + '?pageId='
        + String(story_id)
      );
  }

  lockRelease(story_id) {
      return this.restService.http_get(
        this.config.get('product').baseUrl
        + StaticViewDataService.pageLockReleaseAPI
        + '?pageId='
        + String(story_id)
      );
  }
  customFunc(ev) {
  }

}
